import { useEffect, useState, useSyncExternalStore } from "react";
import { getToasts, subscribeToasts, dismissToast, type ToastItem, type ToastKind } from "../../../toastBus";

const ICONS: Record<ToastKind, string> = {
  success: "bi-check-circle-fill",
  error: "bi-exclamation-triangle-fill",
  info: "bi-info-circle-fill",
};

// Reuses the existing .toast-stack/.app-toast CSS classes directly rather
// than reimplementing the look with styled-components - the visuals are
// already pixel-exact and styles.css stays loaded for the whole migration.
function ToastRow({ toast }: { toast: ToastItem }) {
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setEntered(true));
    return () => cancelAnimationFrame(raf);
  }, []);

  const shown = entered && !toast.leaving;

  return (
    <div
      className={`app-toast app-toast-${toast.kind}${shown ? " show" : ""}`}
      role="status"
      onClick={() => dismissToast(toast.id)}
    >
      <i className={`bi ${ICONS[toast.kind]}`} aria-hidden="true" />
      <span>{toast.message}</span>
    </div>
  );
}

export function ToastHost() {
  const toasts = useSyncExternalStore(subscribeToasts, getToasts);
  if (!toasts.length) return null;

  return (
    <div className="toast-stack" aria-live="polite" aria-atomic="true">
      {toasts.map((t) => (
        <ToastRow key={t.id} toast={t} />
      ))}
    </div>
  );
}
